import type { PublicSellerLegalAddress } from './publicSellerLegalTypes.js';

/** Formats registered address technical fields into one line (no LEGAL prose). */
export function formatSellerLegalAddress(
  address: PublicSellerLegalAddress | null | undefined,
): string | null {
  if (address == null) {
    return null;
  }
  const parts: string[] = [];
  const street = address.street?.trim();
  const zip = address.zip?.trim();
  const city = address.city?.trim();
  const country = address.countryCode?.trim();
  if (street != null && street.length > 0) {
    parts.push(street);
  }
  const cityLine = [zip, city].filter((p) => p != null && p.length > 0).join(' ');
  if (cityLine.length > 0) {
    parts.push(cityLine);
  }
  if (country != null && country.length > 0) {
    parts.push(country);
  }
  return parts.length > 0 ? parts.join(', ') : null;
}
